module.exports = __webpack_public_path__ + "img/золотой букет 90х100.1abf68d5.jpg";